export function formatCurrencyNoRM(value) {
    let val = (value/1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function formatCurrency(value) {
    let val = (value/1).toFixed(2)
    return "RM " +val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}